import React from 'react';
import Grid from '@mui/material/Grid2';
import { 
  CritFail, 
  CritSuccess, 
  D20,
  D4, D6, D8, 
  D10,
  D12
} from "@models/Images";

import { 
  Character,
  CharacterSheetInterface,
  RolledValue,
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";

import ImageFromString from "@dndComponents/display/ImageFromString";
import ButtonBox from "@components/input/buttons/ButtonBox";

interface Props {
  rolled_values?: RolledValue[];
  char?: CharacterSheetInterface;
  name?: string;
  type: string;
  dc?: number;
  separate_flats?: boolean;
}

const common_util = CommonUtilities.getInstance();

export default function Roller({
  rolled_values = [],
  char,
  name = "",
  type,
  dc,
  separate_flats = false
}: Props) {

  const renderRolledValue = (rolled_value: RolledValue, index: number) => {
    let total = 0; // rolled_value.flat;
    const bonuses = separate_flats ? rolled_value.flat : ((d20 && index === -1) || (!d20 && index === 0)) ? bonus : 0;
    const dr = rolled_value;
    // console.log(rolled_value);
    if (dr.size === 1) {
      if (dr.count !== 0) {
        total += dr.count;
        return (
          <Grid
            key={index}
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 6
              }}>
              &nbsp;
            </Grid>
            <Grid
              size={{
                xs: 6
              }}>
              { total }
            </Grid>
          </Grid>
        );
      }
    } else if (dr.count === 0) {
      if (bonuses !== 0) {
        total = bonuses;
        return (
          <Grid
            key={index}
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 6
              }}>
              &nbsp;
            </Grid>
            <Grid
              size={{
                xs: 6
              }}>
              { total }
            </Grid>
          </Grid>
        );
      }
    } else {
      // let roll_string = "";
      let image = "";
      switch(+dr.size) {
        case 4: image = D4; break;
        case 6: image = D6; break;
        case 8: image = D8; break;
        case 10: image = D10; break;
        case 12: image = D12; break;
        case 20: image = D20; break;
      }
      let count = dr.count;
      let reverse = false;
      let joiner = " + ";
      if (count < 0) {
        count *= -1;
        reverse = true;
        joiner = " - ";
      }
      let roll_renders: any = null;
      if (rolled_value.size === 20 && rolled_value.roll_values.length === 1) {
        // Standard d20 roll
        let adv_render: any = null;
        let min_render: any = null;
        let reroll_render: any = null;
        const roll = rolled_value.roll_values[0]; // standard d20 rolls only have one roll
        let val = 0;
        let simple = true;
        if (rolled_value.advantage !== 0) {
          let found = false;
          simple = false;
          if (advantage > 0) {
            val = Math.max(...roll.main_values);
            adv_render = (
              <span>
                { roll.main_values.map((v, key2) => {
                  if (v === val && !found) {
                    found = true;
                    return (
                      <span key={key2}>
                        { key2 > 0 ? ", " : "" }
                        <span style={{ fontWeight: "bold", color: "green" }}>
                          { v }
                        </span>
                      </span>
                    );
                  } else {
                    return (
                      <span key={key2}>
                        { key2 > 0 ? ", " : "" }
                        { v }
                      </span>
                    );
                  }
                })}
              </span>
            );
          } else {
            val = Math.min(...roll.main_values);
            adv_render = (
              <span>
                { roll.main_values.map((v, key2) => {
                  if (v === val && !found) {
                    found = true;
                    return (
                      <span key={key2}>
                        { key2 > 0 ? ", " : "" }
                        <span style={{ fontWeight: "bold", color: "red" }}>
                          { v }
                        </span>
                      </span>
                    );
                  } else {
                    return (
                      <span key={key2}>
                        { key2 > 0 ? ", " : "" }
                        { v }
                      </span>
                    );
                  }
                })}
              </span>
            );
          }
        } else if (roll.main_values.length === 1) {
          val = roll.main_values[0];
          adv_render = (
            <span>
              { val }
            </span>
          );
        }
        if (roll.minrolled && roll.minroll_value) {
          simple = false;
          val = roll.minroll_value;
          min_render = (
            <span>
              &nbsp;Min Used: { roll.minroll_value }
            </span>
          );
          if (roll.rerolled && roll.reroll_value) {
            reroll_render = (
              <span>
                &nbsp;Reroll: { roll.reroll_value }
              </span>
            );
          }
        } else if (roll.rerolled && roll.reroll_value) {
          simple = false;
          val = roll.reroll_value;
          reroll_render = (
            <span>
              &nbsp;Reroll: { roll.reroll_value }
            </span>
          );
        }
        if (val === 20) {
          image = CritSuccess;
        } else if (val === 1) {
          image = CritFail;
        }
        total += val;
        if (simple) {
          roll_renders = adv_render;
        } else {
          roll_renders = <>({ adv_render }{ reroll_render }{ min_render })</>;
        }
      } else {
        for (const roll of rolled_value.roll_values) {
          if (roll.minrolled && roll.minroll_value) {
            total += roll.minroll_value;
          } else if (roll.rerolled && roll.reroll_value) {
            total += roll.reroll_value;
          } else if (roll.main_values.length === 1) {
            total += roll.main_values[0];
          }
        }
        roll_renders = rolled_value.roll_values.map(o => `${o.main_values[0]}`).join(joiner);
      }
      total += bonuses;
      total = reverse ? total * -1 : total;
      return (
        <Grid
          key={index}
          container
          spacing={0}
          direction="row"
          size={{
            xs: 12
          }}>
          <Grid
            size={{
              xs: 6
            }}>
            <img src={image} alt={image} 
              style={{
                width: "40px",
                height: "40px"
              }} 
            />
          </Grid>
          <Grid
            size={{
              xs: 6
            }}>
            { roll_renders }&nbsp;
            { common_util.addPlusMaybe(bonuses, true) }
            { (count > 1 || bonuses !== 0) && ` = ${ total }` }
          </Grid>
        </Grid>
      );
    }
    return null;
  }

  const rollString = (rolled_value: RolledValue) => {
    let str = "";
    if (rolled_value.count === 0 || rolled_value.size === 0) {
      if (rolled_value.flat !== 0) {
        str = `${rolled_value.flat}`;
      }
    } else {
      str = `${rolled_value.count}d${rolled_value.size}`;
      if (rolled_value.flat > 0) {
        str += `+${rolled_value.flat}`;
      } else if (rolled_value.flat < 0) {
        str += `${rolled_value.flat}`;
      }
    }
    return str;
  }

  const damage_type = rolled_values.find(o => o.type !== "")?.type??"";
  const bonus = rolled_values.map(o => o.flat).reduce((a, b) => a + b, 0) + 
    rolled_values.filter(o => o.size === 1).map(o => o.count).reduce((a, b) => a + b, 0);
  const non_flat_rolled_values = rolled_values.filter(o => o.size !== 1 && o.count !== 0).map(o => { 
    return { ...o, flat: 0 };
  });
  let grand_total = 0;
  let advantage = 0;
  const d20 = rolled_values.find(o => o.size === 20 && o.roll_values.length === 1);
  if (d20) {
    const roll = d20.roll_values[0]; // standard d20 rolls only have one roll
    let val = 0;
    if (d20.advantage !== 0) {
      advantage = d20.advantage;
      if (advantage > 0) {
        val = Math.max(...roll.main_values);
      } else {
        val = Math.min(...roll.main_values);
      }
    } else if (roll.main_values.length === 1) {
      val = roll.main_values[0];
    }
    if (roll.minrolled && roll.minroll_value) {
      val = roll.minroll_value;
    } else if (roll.rerolled && roll.reroll_value) {
      val = roll.reroll_value;
    }
    grand_total += val;
  }
  // console.log(non_flat_rolled_values);
  // console.log(grand_total);
  const others = separate_flats ? rolled_values.filter(o => o.size !== 20 || o.roll_values.length > 1) : non_flat_rolled_values.filter(o => o.size !== 20 || o.roll_values.length > 1); // Allow non-standard d20 rolls
  // console.log(others);
  for (const rv of others) {
    for (const roll of rv.roll_values) {
      if (roll.minrolled && roll.minroll_value) {
        grand_total += roll.minroll_value;
      } else if (roll.rerolled && roll.reroll_value) {
        grand_total += roll.reroll_value;
      } else if (roll.main_values.length === 1) {
        grand_total += roll.main_values[0];
      }
    }
  }
  // console.log(grand_total);
  if (!separate_flats) {
    grand_total += bonus;
  }
  // console.log(rolled_values);
  // console.log(non_flat_rolled_values);
  // console.log(grand_total);
  // debugger;
  let top = "";
  if (separate_flats) {
    top = rolled_values.map(o => {
      return rollString(o);
    }).join("+");
  } else {
    top = non_flat_rolled_values.map(o => {
      return rollString(o);
    }).join("+");
    if (bonus !== 0) {
      top += `${common_util.addPlusMaybe(bonus)}`;
    }
  }
  // console.log(type);
  return (
    <Grid container spacing={0} direction="row" 
      style={{
        background: "black"
      }}>
      <Grid
        className="centered header"
        size={{
          xs: 12
        }}>
        <em style={{ 
          fontStyle: "normal",
          color: (["Healing","Temp HP","Max HP"].includes(type) ? "green" : "inherit")
        }}>{ name }</em>&nbsp;
        ({top})
         {/* */}
        { advantage !== 0 &&
          <>&nbsp;
            <em style={{ 
              fontStyle: "normal",
              // color: "gray"
            }}>With 
            </em>&nbsp;
            { advantage > 0 ? 
              <em style={{ 
                fontStyle: "normal",
                color: "green"
              }}>Advantage</em> 
            : 
              <em style={{ 
                fontStyle: "normal",
                color: "red"
              }}>Disadvantage</em> 
            }
          </>
        }
      </Grid>
      <Grid
        container
        spacing={0}
        direction="row"
        style={{ 
          padding: "4px", 
          fontSize: "15px",
        }}
        size={{
          xs: 8
        }}>
        { d20 && renderRolledValue(d20, -1) }
        { others.map((rv, index) => {
          return renderRolledValue(rv, index);
        })}
      </Grid>
      <Grid
        className="centered"
        style={{
          verticalAlign: "middle",
          fontSize: "20px",
          padding: "4px"
        }}
        size={{
          xs: 1
        }}>
        =
      </Grid>
      <Grid
        className="centered"
        style={{
          fontSize: "25px",
          fontWeight: "bold",
          padding: "4px"
        }}
        size={{
          xs: 3
        }}>
        { grand_total }
        { damage_type !== "" && <ImageFromString image={damage_type} size={25} color="white" /> }
      </Grid>
      { dc && 
        <Grid
          size={{
            xs: 12
          }}>
          <em style={{ 
            fontStyle: "normal", 
            // color: "gray"
          }}>{ `DC: ${dc}` }</em>
        </Grid>
      }
      { char && ["Healing","Temp HP","Max HP"].includes(type) &&
        <Grid
          size={{
            xs: 12
          }}>
          <ButtonBox
            name="Apply to Self"
            onClick={() => {
              switch (type) {
                case "Healing": 
                  if (char.body.resource_holder.hp.current + grand_total > char.body.resource_holder.hp.true_max) {
                    char.body.resource_holder.hp.current = char.body.resource_holder.hp.true_max;
                  } else {
                    char.body.resource_holder.hp.current += grand_total;
                  }
                break;
                case "Temp HP": char.body.resource_holder.hp.temp = grand_total; break;
                case "Max HP":
                  char.body.resource_holder.hp.max_modifier += grand_total;
                  char.body.resource_holder.hp.current += grand_total;
                break;
              }
              // console.log(char.body.resource_holder.hp);
              char.changed();
              char.subscription_holder.resourcesChanged();
            }}
          />
        </Grid>
      }
    </Grid>
  );
}
